import styles from './styles.module.scss';

import Tooltip from '../../WrapsStyle/Tooltip';
import Button from '../Button';

const ButtonWithTooltip = ({ tooltip = '', children, position, ...props }) => (
  <Tooltip className={styles.button_wrapper} text={tooltip} position={position} isShow={tooltip.length > 0}>
    <Button {...props}>{children}</Button>
  </Tooltip>
);

export default ButtonWithTooltip;
